import React from "react";
import classNames from "classnames";
import { Folder as F, Identifiable } from "@planzone/dto";

import { Props } from "./types";
import styles from "./styles.scss";

function Folder({
  depth = 1,
  folder,
  rootName,
  selectedFolder,
  select,
}: Props) {
  const isSelected = selectedFolder && selectedFolder.uuid === folder.uuid;

  return (
    <div className={styles.folder}>
      <div
        className={classNames(styles.name, { [styles.selected]: isSelected })}
        style={{ paddingLeft: `${1 * depth}rem` }}
        onClick={() => select(isSelected ? null : folder)}
      >
        <p>{folder.name || (depth === 1 ? rootName : "")}</p>
      </div>
      {folder.children
        .filter(({ type }) => type === "folder")
        .map((child) => (
          <Folder
            rootName={rootName}
            folder={child as Identifiable<F>}
            selectedFolder={selectedFolder}
            select={select}
            depth={depth + 1}
          />
        ))}
    </div>
  );
}

export { Folder };
